:host{display:flex;flex:1;text-align:center;justify-content:center;background-color:#fff;padding:20px 0}
/*# sourceMappingURL=questionnaire-footer.component-DATINSXN.css.map */
